const timestamp = require('@ua/timestamp')
const lookup = require('@ua/dotpathlookup')

const getContext = require('airship/modules/page-context').default

module.exports = lastLoginTimestamp

function lastLoginTimestamp(el) {
  const context = getContext()
  const lastLoginDate = lookup(
    'context_processors.session_info.most_recent.start'
  )(context)
  const dateFormat = el.getAttribute('data-format') || '%FT%T %Z'

  if (!lastLoginDate) return

  el.textContent = timestamp.format(
    timestamp.parse(lastLoginDate),
    timestamp.current_locale(),
    dateFormat
  )
}
